import { memo } from 'react';

import { useForwardWheelScroll } from '@/hooks/useForwardWheelScroll';
import { cn } from '@/lib/utils';

type SubNavShellProps = { children: React.ReactNode; disableHover?: boolean };

const SubNavShell = memo(({ children, disableHover }: SubNavShellProps) => {
  const containerRef = useForwardWheelScroll();

  // Width + padding here define the SubNav footprint that SettingsContent's spacer max-w mirrors to keep content centered — update both together.
  return (
    <div
      ref={containerRef}
      className="flex max-h-screen w-fit shrink-0 flex-col bg-bg-muted-light py-4 pr-2 pl-3 lg:pl-4 xl:pl-5 2xl:pl-7"
    >
      <div
        className={cn(
          'flex w-(--subnav-width) flex-col overflow-hidden rounded-lg border border-transparent bg-transparent transition-colors duration-200',
          !disableHover && 'hover:border-border hover:bg-background hover:duration-0'
        )}
      >
        <nav className="overflow-y-auto p-2">{children}</nav>
      </div>
    </div>
  );
});

SubNavShell.displayName = 'SubNavShell';

export default SubNavShell;
